<template>
  <button @click="goBack" class="btn btn--ghost-primary icon icon--left u-margin-top-0">
    <i class="icon-back"></i> {{ $t('common.back') }}
  </button>
</template>

<script>
export default {
  name: "BackButton",
  props: [
    'goBack'
  ]
}
</script>
